import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    posts: [],
    status: null,
    error: null
}

export const getPartners = createAsyncThunk(
    "partners/getPartners",
    async function(_, {rejectWithValue}){
        const response = await axios.get("https://api.creativelab.am/api/partners");

        if (response.status !== 200){
            throw new Error("Server Error")
        }

        return response.data.partners
    }
)

const PartnersSlice = createSlice({
    name: "partners",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getPartners.pending, state => {
                state.status = "Loading ..."
            })
            .addCase(getPartners.fulfilled, (state, action)=>{
                state.status = "Success";
                state.posts = action.payload
            })
            .addCase(getPartners.rejected, (state, action)=>{
                state.status = "Rejected";
                state.error = action.payload
            })
    }
})

export default PartnersSlice.reducer;